export var avatarShape;
(function (avatarShape) {
    avatarShape["CIRCLE"] = "circle";
    avatarShape["SQUARE"] = "square";
    avatarShape["ROUNDED"] = "rounded";
})(avatarShape || (avatarShape = {}));
export var avatarType;
(function (avatarType) {
    avatarType["INITIALS"] = "initials";
    avatarType["IMAGE"] = "image";
    avatarType["ICON"] = "icon";
})(avatarType || (avatarType = {}));
export var cardOrientation;
(function (cardOrientation) {
    cardOrientation["HORIZONTAL"] = "horizontal";
    cardOrientation["VERTICAL"] = "vertical";
})(cardOrientation || (cardOrientation = {}));
export var cardType;
(function (cardType) {
    cardType["DEFAULT"] = "default";
    cardType["primary"] = "primary";
    cardType["INFO"] = "info";
    cardType["SUCCESS"] = "success";
    cardType["WARNING"] = "warning";
    cardType["ERROR"] = "error";
})(cardType || (cardType = {}));
export var cardActionsLayout;
(function (cardActionsLayout) {
    cardActionsLayout["START"] = "start";
    cardActionsLayout["CENTER"] = "center";
    cardActionsLayout["END"] = "end";
    cardActionsLayout["STRETCHED"] = "stretched";
})(cardActionsLayout || (cardActionsLayout = {}));
//# sourceMappingURL=Enums.js.map